const TrophyBold = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="75"
      viewBox="0 0 75 75"
      width="75"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3397 39.5316L24.0051 27.3604H19.1255L21.4602 39.5316C22.157 43.1527 24.0934 46.418 26.9365 48.7664C29.7796 51.1148 33.3518 52.3996 37.0394 52.4C37.8516 52.3974 38.6621 52.327 39.4626 52.1898C36.2373 51.6896 33.2454 50.205 30.8963 47.9391C28.5472 45.6732 26.9558 42.7368 26.3397 39.5316Z"
        fill="#DBDBDB"
      />
      <path
        d="M31.2416 27.3825H19.3469L21.6927 39.5538C22.3898 43.1708 24.3254 46.432 27.1666 48.7765C30.0079 51.121 33.5772 52.4022 37.2608 52.4C40.9484 52.3996 44.5206 51.1148 47.3637 48.7664C50.2068 46.418 52.1432 43.1527 52.8401 39.5316L55.1747 27.3604H48.5359"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M37.2607 52.3999V66.4411"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M25.9858 66.4409H48.547"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M54.3669 31.6094H64.2367C64.2367 31.6094 63.7831 44.0573 56.9893 48.4611"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M20.0993 31.6094H10.2295C10.2295 31.6094 10.6721 44.0573 17.4769 48.4611"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M37.2608 11.2939L40.713 18.2869L48.4252 19.4044L42.8485 24.8483L44.1652 32.5384L37.2608 28.9091L30.3674 32.5384L31.6842 24.8483L26.0964 19.4044L33.8086 18.2869L37.2608 11.2939Z"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M30.312 13.7174L26.384 9.09229"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M45.2827 13.7174L49.1997 9.09229"
        stroke="#DBDBDB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
};

export default TrophyBold;
